export default __webpack_public_path__ + "static/media/1_home-image.62aa9c15.jpg";